export class Lookup {
    constructor(public data: {
        Id?: Number,
        Name?: String
    }) { }
}